import * as React from 'react';
import { ReactComponent as ProgressCircleAsset } from 'assets/images/DigitalMarketing/progress-circle.svg';

interface ProgressCircleProps {
  score: number;
  radius?: number;
  strokeWidth?: number;
  className?: string;
}

export const ProgressCircle = ({
  score,
  radius = 43,
  strokeWidth = 14,
  className = 'w-full h-full rotate-[132deg]',
}: ProgressCircleProps) => {
  const circumference = 2 * Math.PI * radius;
  const arcLength = circumference * 0.76;
  const progressOffset = arcLength * (1 - score / 100);

  return (
    <ProgressCircleAsset
      className={className}
      style={
        {
          '--radius': radius,
          '--stroke-width': strokeWidth,
          '--arc-length': arcLength,
          '--circumference': circumference,
          '--progress-offset': progressOffset,
        } as React.CSSProperties
      }
      aria-hidden="true"
    />
  );
};
